export default "__VITE_ASSET__EruD9IZM__"